import { getLabel, getLabelsFromStorage } from './helpers';
const getLabelFromStorage = (copyKey, { replacements } = {}, locale) => {
    const allLabels = getLabelsFromStorage(locale);
    return getLabel({ copyKey, replacements, allLabels });
};
export default getLabelFromStorage;
//# sourceMappingURL=getLabelFromStorage.js.map